module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mt-command-bar', {
    attrs: {
      "buttons": _vm.buttons,
      "moreButtons": _vm.moreButtons
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  })], 1)
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./src/components/emap-flow-toolbar.vue